import {
  ApiError,
  MealInsightControllerService,
  UpdateMealInsightRequest
} from "@9amhealth/openapi";
import type { TranslationKey } from "src/types/translationKey";

/**
 * Overrides the wall-clock date/time a meal was eaten.
 *
 * The backend can only set `takenAt` at creation time, through the POST's
 * `takenAtOverride`; the update body it publishes is still status-only, so this
 * call is rejected until `takenAt` is added to `UpdateMealInsightRequest`. The
 * cast is the single seam that change has to touch — everything above it is
 * already wired.
 */
export const patchMealTakenAt = async (
  mealInsightId: string,
  takenAt: string
): Promise<void> => {
  await MealInsightControllerService.updateMealInsight(mealInsightId, {
    takenAt
  } as unknown as UpdateMealInsightRequest);
};

const REFINEMENT_SUPERSEDED_ERROR_STATUS = 409;

export const refineFailureMessage = (error: unknown): TranslationKey =>
  error instanceof ApiError &&
  error.status === REFINEMENT_SUPERSEDED_ERROR_STATUS
    ? "mealInsights.refine.superseded"
    : "mealInsights.refine.error";
